import { environment } from "../environments/environment";

export class ApiRoutesConfig {
    public static get API_URL(): string { return environment.apiUrl }
    public static get API_POSTENQUIRY(): string { return '/Common/postenquiry' };
    public static get API_ValidateOTP(): string { return '/SMS/validateotp?mobile=' };
    public static get API_InstructorEnquery(): string { return '/Common/SaveInstructorProfile' };
    public static get API_InsertUpdateVisitTrackery(): string { return '/Common/InsertUpdateVisitTracker' };
    public static get API_CreateOrUpdateLPUCourseRegistration(): string { return '/Common/CreateOrUpdateLPUCourseRegistration' };
}